export default __webpack_public_path__ + "locales/sl/UploadPanel.json?hash=2308eeb39f92c6b1bfd061da7c66a51e";